import { Link } from "react-router-dom"
import { useState, useEffect } from "react"
import { Ambulance, Phone, Mail, MapPin } from "lucide-react"

export function Footer() {
  const currentYear = new Date().getFullYear()
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false)

useEffect(() => {
  const checkAdminLogin = () => {
    setIsAdminLoggedIn(!!localStorage.getItem("token"))
  }

  checkAdminLogin()

  window.addEventListener("storage", checkAdminLogin)

  return () => {
    window.removeEventListener("storage", checkAdminLogin)
  }
}, [])


  return (
    <footer className="bg-slate-900 text-gray-300">
      {/* ========================================= */}
      {/* MAIN FOOTER CONTENT                      */}
      {/* ========================================= */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">

          {/* COLUMN 1: BRAND & SOCIALS */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-600 text-white">
                <Ambulance className="h-6 w-6" />
              </div>
              <span className="text-xl font-bold text-white">Free Ambulance</span>
            </div>
            <p className="text-sm leading-relaxed text-gray-400">
              Fast, reliable, and completely free emergency medical transport service dedicated to the community, available 24/7.
            </p>

            {/* Social Media Links */}
            <div className="flex space-x-3 pt-2">
              <a
                href="https://www.facebook.com/share/1Dy9ukz2db/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-800 text-gray-400 hover:bg-blue-600 hover:text-white transition-colors duration-200"
                aria-label="Facebook"
              >
                <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-800 text-gray-400 hover:bg-blue-600 hover:text-white transition-colors duration-200"
                aria-label="Twitter"
              >
                <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24"><path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" /></svg>
              </a>
              <a
                href="https://www.instagram.com/moambulanceseba?igsh=N3h2ZG00aTNoam1k"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-800 text-gray-400 hover:bg-pink-600 hover:text-white transition-colors duration-200"
                aria-label="Instagram"
              >
                <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" /></svg>
              </a>
              <a
                href="https://youtube.com/@moambulanceseba?si=dYmI7DwJu9ld2Oen"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-800 text-gray-400 hover:bg-red-600 hover:text-white transition-colors duration-200"
                aria-label="YouTube"
              >
                <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" /></svg>
              </a>
            </div>
          </div>

          {/* COLUMN 2: QUICK LINKS */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4 relative after:content-[''] after:absolute after:bottom-[-8px] after:left-0 after:w-8 after:h-1 after:bg-blue-600 after:rounded-full">
              Quick Links
            </h3>
            <ul className="space-y-3 mt-6">
              {/* Changed href to to for React Router */}
              <li><Link to="/" className="text-sm hover:text-blue-400 transition-colors duration-200 flex items-center gap-2"><span className="text-blue-600">›</span> Home</Link></li>
              <li>
                <a
                  href="/#booking-form"
                  className="text-sm hover:text-blue-400 transition-colors duration-200 flex items-center gap-2"
                >
                  <span className="text-blue-600">›</span> Book Ambulance
                </a>
              </li>
              <li><Link to="/about-us" className="text-sm hover:text-blue-400 transition-colors duration-200 flex items-center gap-2"><span className="text-blue-600">›</span> About Us</Link></li>
              <li><Link to="/services" className="text-sm hover:text-blue-400 transition-colors duration-200 flex items-center gap-2"><span className="text-blue-600">›</span> Our Services</Link></li>
              <li><Link to="/privacy-policy" className="text-sm hover:text-blue-400 transition-colors duration-200 flex items-center gap-2"><span className="text-blue-600">›</span> Privacy Policy</Link></li>
              {isAdminLoggedIn && (
  <li>
    <Link
      to="/admin"
      className="text-sm hover:text-blue-400 transition-colors duration-200 flex items-center gap-2"
    >
      <span className="text-blue-600">›</span> Admin Dashboard
    </Link>
  </li>
)}
            </ul>
          </div>

          {/* COLUMN 3: CONTACT INFO */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4 relative after:content-[''] after:absolute after:bottom-[-8px] after:left-0 after:w-8 after:h-1 after:bg-blue-600 after:rounded-full">
              Contact Us
            </h3>
            <ul className="space-y-4 mt-6">
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-blue-400 mt-0.5 shrink-0" />
                <div>
                  <p className="text-white text-sm font-medium">Emergency 24/7</p>
                  <p className="text-sm">9776696669, 9348616669,9006706355</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-blue-400 mt-0.5 shrink-0" />
                <div>
                  <p className="text-white text-sm font-medium">Email Us</p>
                  <p className="text-sm">moambulanceseba@gmail.com</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-blue-400 mt-0.5 shrink-0" />
                <div>
                  <p className="text-white text-sm font-medium">Location</p>
                  <p className="text-sm">Dharmadaspur, Mahanga, Cuttack, Pin: 754204</p>
                </div>
              </li>
            </ul>
          </div>

          {/* COLUMN 4: MEMORIAL / TRUST MESSAGE */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4 relative after:content-[''] after:absolute after:bottom-[-8px] after:left-0 after:w-8 after:h-1 after:bg-blue-600 after:rounded-full">
              Our Mission
            </h3>
            <div className="mt-6 p-4 bg-slate-800/50 border border-slate-700 rounded-lg">
              <p className="text-sm leading-relaxed italic text-gray-400">
                "Dedicated in loving memory of <span className="text-white font-medium not-italic">Late Basanta Kumar Nath</span>. His vision of free healthcare for all lives on through this service."
              </p>
            </div>
          </div>

        </div>

        {/* ========================================= */}
        {/* BOTTOM BAR                                */}
        {/* ========================================= */}
        <div className="border-t border-slate-800 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <span>© {currentYear} Free Ambulance Service. All rights reserved.</span>
          </div>
          <div className="flex items-center gap-1 text-sm text-gray-500">
            <span>Made with</span>
            <span className="text-red-500 text-lg leading-none">❤</span>
            <span>by</span>
            <a href="https://vichaarlab.com" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 font-medium transition-colors ml-1">
              Vichaarlab
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}